// PC 用户中心作品分页大小。
export const USER_CENTER_PAGE_SIZE = 10;
// PC 用户中心消息分页大小。
export const USER_CENTER_MESSAGE_PAGE_SIZE = 20;
// PC 用户中心“我的评论”分页大小。
export const USER_CENTER_REPLY_PAGE_SIZE = 20;
// PC 用户中心积分展示上限。
export const USER_CENTER_MAX_POINTS_VALUE = 999999;
